import {LlmToolCategoryType} from '@toolify/server/src/services/LlmService/enum/LlmToolCategoryType'
import {IconNameType} from '@toolify/server/src/enum/IconNameType'

export const LlmToolCategoryDisplayMap = {
  [LlmToolCategoryType.Read]: {
    iconNameType: IconNameType.Eye,
    labelKey: 'chat.llmToolCategory.read',
  },
  [LlmToolCategoryType.Create]: {
    iconNameType: IconNameType.Plus,
    labelKey: 'chat.llmToolCategory.create',
  },
  [LlmToolCategoryType.Update]: {
    iconNameType: IconNameType.Pen,
    labelKey: 'chat.llmToolCategory.update',
  },
  [LlmToolCategoryType.Delete]: {
    iconNameType: IconNameType.Trash,
    labelKey: 'chat.llmToolCategory.delete',
  },
}
